import { OnboardingModes } from './enums';
import * as yup from 'yup';

const onboardingTopicSchema = yup.string().required();
const onboardingModesSchema = yup.string().oneOf(Object.values(OnboardingModes));

export { onboardingModesSchema, onboardingTopicSchema };
